<app-indeterminate-loader *ngIf="isLoading | async"></app-indeterminate-loader>
<router-outlet></router-outlet>
<!--
  Banner de consentimiento DESACTIVADO a proposito (3812e507, 12-ago-2026).
  Para reactivarlo: descomentar esta linea y volver a agregar PrivacyBannerComponent
  a los `imports` del AppComponent. El centro de preferencias sigue disponible en
  /privacy/preferences, solo que sin banner que lo ofrezca.
-->
<!-- <app-privacy-banner></app-privacy-banner> -->
<!-- Breakpoint Debug -->
<div
  class="absolute z-60 w-full h-full top-0 pointer-events-none debug-area"
  [ngClass]="debugActive ? 'block' : 'hidden'"
>
  <div
    class="border border-slate-500 bg-white shadow-md overflow-auto max-w-lg w-full max-h-full pointer-events-auto"
    cdkDragBoundary=".debug-area"
    cdkDrag
    cdkAccordion
  >
    <cdk-accordion-item #accordionItemBreakpoint="cdkAccordionItem">
      <div
        class="p-2 bg-slate-200 border-slate-500 cursor-move"
        cdkDragHandle
        [ngClass]="accordionItemBreakpoint.expanded ? 'border-b' : ''"
      >
        <div class="flex justify-between items-center">
          <div class="font-semibold text-xs text-slate-800">Breakpoint</div>
          <button
            class="text-slate-400 hover:text-slate-500"
            (click)="accordionItemBreakpoint.toggle()"
            data-testid="app-debug-breakpoint-toggle-btn"
            data-test-desc="Boton para expandir o colapsar panel de breakpoints"
          >
            <div class="sr-only">Close</div>
            <svg
              viewBox="0 0 12 12"
              class="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400"
              [ngClass]="
                accordionItemBreakpoint.expanded ? 'rotate-180' : 'rotate-0'
              "
            >
              <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"></path>
            </svg>
          </button>
        </div>
      </div>
      <div
        class="p-2"
        [ngClass]="accordionItemBreakpoint.expanded ? 'block' : 'hidden'"
      >
        <div class="text-xs">
          <div class="font-medium text-slate-800 mb-2">Active Breakpoint</div>

          <div
            class="inline-flex px-4 py-2 rounded-sm text-sm bg-white shadow-lg border border-slate-200 text-slate-600 xs:bg-gl-blue xs:text-white"
          >
            <div class="flex w-full justify-between items-start">
              <div class="flex">
                <div>XS.</div>
              </div>
            </div>
          </div>

          <div
            class="inline-flex px-4 py-2 rounded-sm text-sm bg-white shadow-lg border border-slate-200 text-slate-600 sm:bg-gl-blue sm:text-white"
          >
            <div class="flex w-full justify-between items-start">
              <div class="flex">
                <div>SM.</div>
              </div>
            </div>
          </div>

          <div
            class="inline-flex px-4 py-2 rounded-sm text-sm bg-white shadow-lg border border-slate-200 text-slate-600 md:bg-gl-blue md:text-white"
          >
            <div class="flex w-full justify-between items-start">
              <div class="flex">
                <div>MD.</div>
              </div>
            </div>
          </div>

          <div
            class="inline-flex px-4 py-2 rounded-sm text-sm bg-white shadow-lg border border-slate-200 text-slate-600 lg:bg-gl-blue lg:text-white"
          >
            <div class="flex w-full justify-between items-start">
              <div class="flex">
                <div>LG.</div>
              </div>
            </div>
          </div>

          <div
            class="inline-flex px-4 py-2 rounded-sm text-sm bg-white shadow-lg border border-slate-200 text-slate-600 xl:bg-gl-blue xl:text-white"
          >
            <div class="flex w-full justify-between items-start">
              <div class="flex">
                <div>XL.</div>
              </div>
            </div>
          </div>

          <div
            class="inline-flex px-4 py-2 rounded-sm text-sm bg-white shadow-lg border border-slate-200 text-slate-600 2xl:bg-gl-blue 2xl:text-white"
          >
            <div class="flex w-full justify-between items-start">
              <div class="flex">
                <div>2XL.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cdk-accordion-item>
  </div>
</div>

<!-- Session Debug -->
<div
  class="absolute z-60 w-full h-full top-0 pointer-events-none debug-area"
  [ngClass]="debugActive ? 'block' : 'hidden'"
>
  <div
    class="border border-slate-500 bg-white shadow-md overflow-auto max-w-lg w-full max-h-full pointer-events-auto"
    cdkDragBoundary=".debug-area"
    cdkDrag
    cdkAccordion
  >
    <cdk-accordion-item #accordionItemAuth="cdkAccordionItem">
      <div
        class="p-2 bg-slate-200 border-slate-500 cursor-move"
        cdkDragHandle
        [ngClass]="accordionItemAuth.expanded ? 'border-b' : ''"
      >
        <div class="flex justify-between items-center">
          <div class="font-semibold text-xs text-slate-800">Session Auth</div>
          <button
            class="text-slate-400 hover:text-slate-500"
            (click)="accordionItemAuth.toggle()"
            data-testid="app-debug-session-toggle-btn"
            data-test-desc="Boton para expandir o colapsar panel de sesion"
          >
            <div class="sr-only">Close</div>
            <svg
              viewBox="0 0 12 12"
              class="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400"
              [ngClass]="accordionItemAuth.expanded ? 'rotate-180' : 'rotate-0'"
            >
              <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"></path>
            </svg>
          </button>
        </div>
      </div>
      <div
        class="p-2"
        [ngClass]="accordionItemAuth.expanded ? 'block' : 'hidden'"
      >
        <div class="text-xs" *ngIf="!sessionExist">
          <div class="font-medium text-slate-800 mb-2">
            Autenticación de la Sesión
          </div>
          <div
            class="inline-flex flex-col px-4 py-2 rounded-sm text-sm bg-white shadow-sm border border-slate-200 text-slate-600 w-full"
          >
            <div class="flex w-full justify-between items-start">
              <div class="flex">
                <svg
                  class="w-4 h-4 shrink-0 fill-current text-amber-500 mt-[3px] mr-3"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
                  ></path>
                </svg>
                <div>
                  <div class="font-medium text-slate-800 mb-1">
                    Sin Información de Autenticación de la Sesión
                  </div>
                  <div>
                    No existe token de acceso en el navegador para depurar la
                    sesión.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="sessionExist" class="text-xs">
          <div class="font-medium text-slate-800 mb-2">
            Autenticación de la Sesión
          </div>
          <div class="space-y-2">
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Session Update In</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="updateSessionRT"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Access Token</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="sessionAuthState.access_token"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Access Token Duration</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="accessTokenID"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Access Token Expires In</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="accessTokenRT"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Refresh Token</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="sessionAuthState.refresh_token"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Refresh Token Duration</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="refreshTokenID"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Refresh Token Expires In</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="refreshTokenRT"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Permissions Hash</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="sessionAuthState.permissions_hash"
              />
            </div>
            <div>
              <label class="block text-xs font-medium mb-1" for=""
                >Data User Hash</label
              >
              <input
                readonly
                class="form-input w-full !px-2 !py-1"
                type="text"
                [(ngModel)]="sessionAuthState.data_user_hash"
              />
            </div>
          </div>
        </div>
      </div>
    </cdk-accordion-item>
  </div>
</div>

<!-- Breakpoint Debug -->
<div
  class="absolute z-60 w-full h-full top-0 pointer-events-none debug-area"
  [ngClass]="debugActive ? 'block' : 'hidden'"
>
  <div
    class="border border-slate-500 bg-white shadow-md overflow-auto max-w-lg w-full max-h-full pointer-events-auto"
    cdkDragBoundary=".debug-area"
    cdkDrag
    cdkAccordion
  >
    <cdk-accordion-item #accordionItemTest="cdkAccordionItem">
      <div
        class="p-2 bg-slate-200 border-slate-500 cursor-move"
        cdkDragHandle
        [ngClass]="accordionItemTest.expanded ? 'border-b' : ''"
      >
        <div class="flex justify-between items-center">
          <div class="font-semibold text-xs text-slate-800">Debug Panel</div>
          <button
            class="text-slate-400 hover:text-slate-500"
            (click)="accordionItemTest.toggle()"
            data-testid="app-debug-test-toggle-btn"
            data-test-desc="Boton para expandir o colapsar panel de debug"
          >
            <div class="sr-only">Close</div>
            <svg
              viewBox="0 0 12 12"
              class="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400"
              [ngClass]="accordionItemTest.expanded ? 'rotate-180' : 'rotate-0'"
            >
              <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"></path>
            </svg>
          </button>
        </div>
      </div>
      <div
        class="p-2"
        [ngClass]="accordionItemTest.expanded ? 'block' : 'hidden'"
      >
        <div class="text-xs">
          <div class="font-medium text-slate-800">Inner Debug Panel</div>
        </div>
      </div>
    </cdk-accordion-item>
  </div>
</div>
